var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M15.565 5.8h-.28L12 10.242c-.76-2.431.618-6.88 1.555-9.242a9.87 9.87 0 0 0-4.92 1.633C7.155 3.61 6.335 5.889 5.5 7.5l-2.214-2.78a8.54 8.54 0 0 0-2.11 4.131 8.8 8.8 0 0 0 .326 4.676 8.4 8.4 0 0 0 2.662 3.763 7.8 7.8 0 0 0 4.169 1.68 7.7 7.7 0 0 0 4.376-.928 8.2 8.2 0 0 0 3.221-3.247 8.74 8.74 0 0 0 1.063-4.554A8.7 8.7 0 0 0 15.565 5.8"
  })));
};
export default SvgFlame;